/**
 * TypeScript interfaces for Custom Types API response
 * GET /apps/public-websearch-chatbot-client/api/v1/customtypes
 */

/**
 * Enum for chatbot position options
 */
export enum ChatbotPosition {
  BottomLeft = 1,
  BottomRight = 2,
}

/**
 * Enum values for chatbot icons
 */
export enum ChatbotIcon {
  Chatbot1 = 1,
  Chatbot2 = 2,
  Chatbot3 = 3,
  Chatbot4 = 4,
  UserDefined = 99,
}

/**
 * Enum for CMS theme colors (received from microservice)
 */
export enum CmsThemeColor {
  PrimaryColor = 1,
  SecondaryColor = 2,
}

/**
 * Interface for ChatbotPositionEnum from API response
 */
export interface ChatbotPositionEnum {
  BottomLeft: number;
  BottomRight: number;
}

/**
 * Interface for ChatbotIconEnum from API response
 */
export interface ChatbotIconEnum {
  Chatbot1: string;
  Chatbot2: string;
  Chatbot3: string;
  Chatbot4: string;
  UserDefined: string;
}

/**
 * Interface for CmsThemeColorEnum from API response
 */
export interface CmsThemeColorEnum {
  PrimaryColor: number;
  SecondaryColor: number;
}

/**
 * Interface for FeedbackResultEnum from API response
 */
export interface FeedbackResultEnum {
  Solved: number;
  NotHelpful: number;
}

/**
 * Interface for the enums object in API response
 */
export interface CustomTypesEnums {
  ChatbotPositionEnum: ChatbotPositionEnum;
  ChatbotIconEnum: ChatbotIconEnum;
  CmsThemeColorEnum: CmsThemeColorEnum;
  FeedbackResultEnum: FeedbackResultEnum;
}

/**
 * Interface for configuration object in custom types response
 */
export interface CustomTypesConfiguration {
  SessionTimeoutSec: number;
}

/**
 * Interface for the payload of custom types API response
 */
export interface CustomTypesPayload {
  enums: CustomTypesEnums;
  configuration: CustomTypesConfiguration;
}

/**
 * Interface for service metadata in API responses
 */
export interface ServiceResponse {
  errorCode: number;
  errorMessage: string | null;
}

/**
 * Interface for the complete custom types API response
 */
export interface CustomTypesResponse {
  service: ServiceResponse;
  payload: CustomTypesPayload;
}
